import { IOption } from "../../Components/dropdown-input-component";

export const SourceOfPromotions: IOption[] = [
    { key: "Campion", text: "Campion", value: "Campion" },
    { key: "Banner Hoardings", text: "Banner Hoardings", value: "Banner Hoardings" },
    { key: "Call", text: "Call", value: "Call" },
    { key: "Google", text: "Google", value: "Google" },
    { key: "Facebook", text: "Facebook", value: "Facebook" },
    { key: "Newspaper", text: "Newspaper", value: "Newspaper" },
    { key: "Instagram", text: "Instagram", value: "Instagram" },
    { key: "Website", text: "Website", value: "Website" },
    { key: "Referred by Member", text: "Referred by Member", value: "Referred by Member" },
    { key: "Referred by Friends Others", text: "Referred by Friends Others", value: "Referred by Friends Others" },
    { key: "Referred by Employee", text: "Referred by Employee", value: "Referred by Employee" },
    { key: "Referred by Customer", text: "Referred by Customer", value: "Referred by Customer" },
    { key: "Walk - In", text: "Walk - In", value: "Walk - In" },
    { key: "Brochure Pamphlet", text: "Brochure Pamphlet", value: "Brochure Pamphlet" },
    { key: "Social Media", text: "Social Media", value: "Social Media" },
    { key: "Television Add", text: "Television Add", value: "Television Add" },
    { key: "Internet Marketing", text: "Internet Marketing", value: "Internet Marketing" },
    { key: "Email Marketing", text: "Email Marketing", value: "Email Marketing" },
    { key: "SMS Marketing", text: "SMS Marketing", value: "SMS Marketing" },
    { key: "News Advertisement", text: "News Advertisement", value: "News Advertisement" },
    { key: "Direct Traffic", text: "Direct Traffic", value: "Direct Traffic" },
    { key: "Inbound Email", text: "Inbound Email", value: "Inbound Email" },
    { key: "Inbound Phone call", text: "Inbound Phone call", value: "Inbound Phone call" },
    { key: "Organic Search", text: "Organic Search", value: "Organic Search" },
    { key: "Outbound Phone call", text: "Outbound Phone call", value: "Outbound Phone call" },
    { key: "Partner Referral", text: "Partner Referral", value: "Partner Referral" },
    { key: "Pay per Click Ads", text: "Pay per Click Ads", value: "Pay per Click Ads" },
    { key: "Referral Sites", text: "Referral Sites", value: "Referral Sites" },
    { key: "Trade Show", text: "Trade Show", value: "Trade Show" },
    { key: "Unknown", text: "Unknown", value: "Unknown" },
    { key: "Other", text: "Other", value: "Other" },
]